import { onStartupComplete } from './startup-perf-logger';

const IDLE_FALLBACK_MS = 2500;

export function scheduleDeferredStartupTask(task: () => void): () => void {
  let cancelled = false;
  let idleCallbackId: number | undefined;
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const runTask = () => {
    if (cancelled) {
      return;
    }
    task();
  };

  const schedule = () => {
    if (cancelled) {
      return;
    }
    if (typeof requestIdleCallback !== 'undefined') {
      idleCallbackId = requestIdleCallback(runTask, {
        timeout: IDLE_FALLBACK_MS,
      });
      return;
    }
    timeoutId = setTimeout(runTask, IDLE_FALLBACK_MS);
  };

  const unsubscribe = onStartupComplete(() => {
    schedule();
  });

  return () => {
    cancelled = true;
    unsubscribe();
    if (
      idleCallbackId !== undefined &&
      typeof cancelIdleCallback !== 'undefined'
    ) {
      cancelIdleCallback(idleCallbackId);
    }
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }
  };
}
